<template>
  <div class="hello">
    <div class="headBox">
      <div class="head">
        <ul class="head_ul" v-if="!isLogin">
          <li class="head_ul_li" @click="toLogin" v-if="path !== 'group'">
            登录
          </li>
          <!-- <li>|</li>
          <li class="head_ul_li" @click="toRegister">免费注册</li> -->
        </ul>
        <ul class="head_ul" v-else>
          <li class="head_ul_li" @click="toUserInfo">
            <!-- 欢迎您,{{ username.contact_name }} -->
            欢迎您,{{ username.nickName }}
          </li>
          <li>|</li>
          <li class="head_ul_li" @click="signOut">注销</li>
        </ul>
      </div>
    </div>
    <!-- logo部分 -->
    <div class="logoBox">
      <div class="main logoInfo">
        <div style="display: flex; align-items: center">
          <div class="logoImg">
            <img src="../assets/logo.jpg" alt="" @click="goHome" />
          </div>
          <p style="font-size: 24px; margin-left: 10px; color: #159b2e">
            园林惠
          </p>
        </div>
        <div class="right_phone" v-if="path !== 'group'">
          <i class="iconfont icon-phone"></i>
          <div>
            <p class="phone">131 6252 0885</p>
            <p class="phone_title">全国服务热线</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 导航栏 -->
    <div class="nav_box">
      <ul class="nav_list">
        <li @click="goHome" v-if="path !== 'group'">苗木市场</li>
        <li @click="goTeam">团队展示</li>
        <!-- <li>
          网站首页
          <ul class="nav_list_children">
            <li>导航一</li>
            <li>导航二导航二</li>
            <li>导航三</li>
          </ul>
        </li>
        <li>
          网站首页
          <ul class="nav_list_children">
            <li>导航一</li>
            <li>导航导航导航</li>
            <li>导航三</li>
          </ul>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import store from "../store";
export default {
  name: "HeaderInfo",
  data() {
    return {
      token: store.state.account.loginToken,
      username: store.state.account.user,
      isLogin: false,
      path: "",
    };
  },
  created() {
    let pathQuery = this.$route.query.path
      ? this.$route.query.path
      : localStorage.getItem("path");
    if (pathQuery) {
      localStorage.setItem("path", pathQuery);
      this.path = pathQuery;
    }

    let token = localStorage.getItem("TOKEN");
    let username = localStorage.getItem("USER");

    if (token && username) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },

  methods: {
    goHome() {
      if (this.path !== "group") {
        this.$router.push("/");
      }
    },
    goTeam() {
      this.$router.push("/teamList");
    },
    toLogin() {
      this.$router.push("/login");
    },
    toRegister() {
      this.$router.push("/register");
    },
    toUserInfo() {
      this.$router.push("/userInfo");
    },
    // 退出登录
    signOut() {
      this.$db.clear();
      // this.$delete(`admin/user/login_out`);
      // 刷新页面
      // location.reload();
      this.$router.push("/");
      location.reload();

      this.isLogin = false;
    },
  },
};
</script>

<style scoped>
.headBox {
  width: 100%;
  height: 36px;
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
}
.logoBox {
  width: 100%;
  background: #fff;
  padding: 10px 0 10px 0;
}
.head {
  width: 1200px;
  margin: 0 auto;
  height: 36px;
  line-height: 36px;
  display: flex;
  justify-content: flex-end;
}
.head_ul {
  display: flex;
  height: 100%;
  list-style: none;
  font-size: 13px;
}
.head_ul > li {
  margin-left: 10px;
  color: #ccc;
  cursor: pointer;
}
.head_ul_li:hover {
  color: #dc5b56;
}

.logoInfo {
  padding-top: 10px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logoImg {
  width: 80px;
}
.right_phone {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.icon-phone {
  font-size: 54px;
  color: #20ab3a;
  margin-right: 10px;
}
.phone {
  color: #20ab3a;
  font-size: 24px;
  font-weight: bold;
}
.phone_title {
  color: #666;
  font-size: 14px;
}

.nav_box {
  width: 100%;
  height: 60px;
  background: #20ab3a;
}
.nav_list {
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  display: flex;
  line-height: 60px;
  /* align-items: center; */
  list-style: none;
}
.nav_list > li {
  padding: 0px 30px 0px 30px;
  color: #fff;
  position: relative;
  cursor: pointer;
}
.nav_list > li:hover {
  background: #159b2e;
}
.nav_list > li:hover .nav_list_children {
  display: block;
}
.nav_list_children {
  display: none;
  width: 120px;
  position: absolute;
  left: 0;
  background: rgba(68, 68, 68, 0.9);
  list-style: none;
  padding: 0px 30px 0px 30px;
  z-index: 50;
}
</style>
